import { TABLE_HEADER_CLASS } from '@/styles/dataTableBg';

export const ACTIONS_COLUMN_ID = 'actions';

export const SERIAL_COLUMN_ID = 'serial';

export const BODY_CELL_PADDING_CLASS = 'px-4 py-1.5';

export const BODY_ROW_CLASS = 'h-12 border-b border-border/50 bg-card transition-colors';

export const DIALOG_TABLE_FRAME_CLASS = 'max-h-80 ring-primary/25 lg:min-h-0';

export const STICKY_TABLE_HEADER_CLASS = `sticky top-0 z-20 ${TABLE_HEADER_CLASS} [&_tr]:border-b-0`;
